import React, { useEffect, useState } from "react";
import { useParams, useNavigate, useLocation, Link } from "react-router-dom";
import { supabase } from "../../lib/supabaseClient.ts";

function SubcategoryPage() {
  const { id: categoryId, name: categoryName } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const params = new URLSearchParams(location.search);

  const selectedCategory = params.get("category") || categoryName || "";
  const selectedSubcategory = params.get("subcategory") || "";

  const [subcategories, setSubcategories] = useState([]);
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768); // mobile breakpoint
    checkMobile(); // initial check
    window.addEventListener("resize", checkMobile); // update on resize
    return () => window.removeEventListener("resize", checkMobile);
  }, []);
  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);

      // Fetch subcategories
      const { data: subData, error: subError } = await supabase
        .from("subcategories")
        .select("*")
        .eq("category_id", categoryId)
        .order("order", { ascending: true });

      if (subError) {
        console.error("Error fetching subcategories:", subError);
        setSubcategories([]);
      } else {
        setSubcategories(subData);
      }

      // Fetch products if no subcategories
      if (!subData || subData.length === 0) {
        const { data: prodData, error: prodError } = await supabase
          .from("products")
          .select(`
            id,
            name,
            image,
            category,
            subcategory,
            price_range,
            old_price,
            stock_status,
            promo,
            promo_percentage,
            promo_type
          `);

        if (prodError) {
          console.error("Error fetching products:", prodError);
          setProducts([]);
        } else {
          // Filter products with proper JSON parsing
          const filtered = (prodData || []).filter((product) => {
            let productCategories = [];
            let productSubcategories = [];

            // Parse category
            try {
              if (typeof product.category === 'string') {
                productCategories = JSON.parse(product.category);
              } else if (Array.isArray(product.category)) {
                productCategories = product.category;
              } else {
                productCategories = [product.category];
              }

              if (!Array.isArray(productCategories)) {
                productCategories = [productCategories];
              }
            } catch (e) {
              productCategories = product.category ? [product.category] : [];
            }

            // Parse subcategory
            try {
              if (typeof product.subcategory === 'string') {
                productSubcategories = JSON.parse(product.subcategory);
              } else if (Array.isArray(product.subcategory)) {
                productSubcategories = product.subcategory;
              } else {
                productSubcategories = [product.subcategory];
              }

              if (!Array.isArray(productSubcategories)) {
                productSubcategories = [productSubcategories];
              }
            } catch (e) {
              productSubcategories = product.subcategory ? [product.subcategory] : [];
            }

            // Normalize
            productCategories = productCategories
              .filter(c => c)
              .map(c => c.toString().trim().toLowerCase());

            productSubcategories = productSubcategories
              .filter(s => s)
              .map(s => s.toString().trim().toLowerCase());

            const selectedCat = selectedCategory.trim().toLowerCase();
            const selectedSub = selectedSubcategory?.trim().toLowerCase();

            // Match category
            const matchCategory = selectedCat
              ? productCategories.includes(selectedCat)
              : true;

            // Match subcategory
            const matchSubcategory = selectedSub
              ? productSubcategories.includes(selectedSub)
              : true;

            return matchCategory && matchSubcategory;
          });

          console.log("Filtered products:", filtered.length);
          setProducts(filtered);
        }
      } else {
        setProducts([]);
      }

      setLoading(false);
    };

    fetchData();
  }, [categoryId, selectedCategory, selectedSubcategory]);

  // Navigate to subcategory
  const handleSubcategoryClick = (subcategoryName) => {
    navigate(
      `/products?category=${encodeURIComponent(
        categoryName
      )}&subcategory=${encodeURIComponent(subcategoryName)}`
    );
  };

  const filteredProducts = products;

  return (
    <div className="container pt-5 pb-5">
      {/* Retour button */}
      <div className="mb-4">
        <button
          onClick={() => navigate(-1)}
          style={{
            padding: "8px 12px",
            borderRadius: "50%",
            backgroundColor: "#fce5ef",
            border: "none",
            cursor: "pointer",
            color: "#c71585",
            fontSize: "20px",
            display: "inline-flex",
            alignItems: "center",
            justifyContent: "center",
            boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          }}
          aria-label="Retour"
        >
          ←
        </button>
      </div>

      <h3 className="mb-4">
        Catégorie: {selectedCategory}{" "}
        {selectedSubcategory && `> ${selectedSubcategory}`}
      </h3>

      {loading ? (
        <p>Chargement...</p>
      ) : subcategories.length > 0 ? (
        // Render subcategories
        <div className="row">
          {subcategories.map((sub) => (
            <div key={sub.id} className="col-lg-3 col-md-4 col-sm-6 mb-4">
              <div
                onClick={() => handleSubcategoryClick(sub.name)}
                style={{
                  cursor: "pointer",
                  border: "1px solid #ddd",
                  borderRadius: "12px",
                  textAlign: "center",
                  height: "180px",
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "center",
                  backgroundColor: "#fff",
                  boxShadow: "0 4px 8px rgba(0,0,0,0.05)",
                  transition: "transform 0.2s",
                }}
              >
                <img
                  src={sub.image}
                  alt={sub.name}
                  style={{
                    width: "80px",
                    height: "80px",
                    objectFit: "cover",

                    margin: "0 auto",
                    borderRadius: "8px",
                  }}
                />
                <span style={{ marginTop: "12px", fontWeight: "600" }}>
                  {sub.name}
                </span>
              </div>
            </div>
          ))}
        </div>
      ) : (
        // Render products if no subcategories
        <div className="row justify-content-center">
          {filteredProducts.length > 0 ? (
            filteredProducts.map((product) => (
              <div
                key={product.id}
                className="col-12 col-sm-6 col-md-4 col-lg-3 mb-4 d-flex justify-content-center"
              >
                <div
                  className="shop-item text-center"
                  style={{
                    border: "1px solid #eee",
                    borderRadius: "8px",
                    padding: "10px",
                    maxWidth: "200px",
                    width: "100%",
                    position: "relative"
                  }}
                >
                  <Link to={`/shop-details/${product.id}`}>
                    <div style={{ position: "relative", display: "inline-block", width: "100%" }}>
                      <img
                        src={product.image}
                        alt={product.name}
                        style={{
                          width: "100%",
                          height: "150px",
                          objectFit: "cover",
                          marginLeft: isMobile ? "90px" : "0", 
                          borderRadius: "6px",
                          marginBottom: "10px",
                        }}
                      />

                      {/* Stock status badge */}
                      <div
                        style={{
                          position: "absolute",
                          top: "10px",
                          left: "10px",
                          backgroundColor:
                            (product.stock_status || "en stock")
                              .toLowerCase() === "en stock"
                              ? "#28a745"
                              : "#dc3545",
                          color: "#fff",
                          padding: "4px 8px",
                          borderRadius: "12px",
                          fontSize: "12px",
                          fontWeight: "600",
                          zIndex: 0,
                        }}
                      >
                        {product.stock_status || "en stock"}
                      </div>

                      {/* Promo Badge */}
                      {product.promo && (
                        <div
                          style={{
                            position: "absolute",
                            top: "10px",
                            right: "10px",
                            background: "linear-gradient(135deg, #28a745 0%, #20c997 100%)",
                            color: "#fff",
                            padding: "4px 10px",
                            borderRadius: "14px",
                            fontSize: "11px",
                            fontWeight: "700",
                            zIndex: 10,
                            boxShadow: "0 2px 8px rgba(40, 167, 69, 0.4)",
                            letterSpacing: "0.3px"
                          }}
                        >
                          {product.promo_type === 'percentage' && product.promo_percentage
                            ? `-${product.promo_percentage}%`
                            : '🎉 PROMO'}
                        </div>
                      )}
                    </div>
                  </Link>

                  <h5 className="mt-2" style={{ fontSize: "0.95rem", marginBottom: "8px" }}>
                    {product.name}
                  </h5>

                  {/* Price Display */}
                  {product.price_range != 0 && (
                    <div style={{ marginTop: "10px" }}>
                      {product.promo ? (
                        // PROMO ACTIVE - Show both old and new price
                        <div style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "4px" }}>
                          {/* Old Price - Strikethrough */}
                          {product.old_price && (
                            <div style={{ position: "relative", display: "inline-block" }}>
                              <span style={{
                                color: "#999",
                                fontSize: "0.85rem",
                                fontWeight: "500"
                              }}>
                                {parseFloat(product.old_price).toLocaleString('fr-FR', {
                                  minimumFractionDigits: 3,
                                  maximumFractionDigits: 3
                                })} DT
                              </span>
                              {/* Strikethrough line */}
                              <div style={{
                                position: "absolute",
                                top: "50%",
                                left: "-2px",
                                right: "-2px",
                                height: "1.5px",
                                background: "#ff4444",
                                transform: "translateY(-50%)"
                              }} />
                            </div>
                          )}

                          {/* New Promo Price */}
                          <div>
                            <span style={{
                              color: "#ff1493",
                              fontWeight: "800",
                              fontSize: "1.1rem"
                            }}>
                              {(() => {
                                let finalPrice = parseFloat(product.price_range);

                                // If percentage promo and old_price exists, calculate
                                if (product.promo_type === 'percentage' && product.promo_percentage && product.old_price) {
                                  finalPrice = parseFloat(product.old_price) * (1 - product.promo_percentage / 100);
                                }

                                return finalPrice.toLocaleString('fr-FR', {
                                  minimumFractionDigits: 3,
                                  maximumFractionDigits: 3
                                });
                              })()} DT
                            </span>
                          </div>

                          {/* Savings Amount */}
                          {product.old_price && (
                            <div style={{
                              fontSize: "0.7rem",
                              color: "#28a745",
                              fontWeight: "600",
                              backgroundColor: "#d4edda",
                              padding: "2px 8px",
                              borderRadius: "10px",
                              marginTop: "2px"
                            }}>
                              Économisez {(parseFloat(product.old_price) - parseFloat(product.price_range)).toLocaleString('fr-FR', {
                                minimumFractionDigits: 3,
                                maximumFractionDigits: 3
                              })} DT
                            </div>
                          )}
                        </div>
                      ) : (
                        // NO PROMO - Show regular price
                        <span style={{
                          color: "#ff1493",
                          fontWeight: "bold",
                          fontSize: "1rem"
                        }}>
                          {parseFloat(product.price_range).toLocaleString('fr-FR', {
                            minimumFractionDigits: 3,
                            maximumFractionDigits: 3
                          })} DT
                        </span>
                      )}
                    </div>
                  )}
                </div>
              </div>
            ))
          ) : (
            <p className="text-center">Aucun produit trouvé.</p>
          )}
        </div>
      )}
    </div>
  );
}

export default SubcategoryPage;
